import { PlainNotificationEndpointModel } from './plain-notification-endpoint';
export class NotificationEndpointModel extends PlainNotificationEndpointModel {
    description;
    url;
    apiToken;
    appKey;
    apiKey;
    serviceKey;
    messageType;
    routingKey;
    serviceApiKey;
    headers;
    method;
}
//# sourceMappingURL=notification-endpoint.js.map